define.alias("shared/components/shared/post/secondary/activity/action", "media/components/shared/post/secondary/activity/action");